import React, { useState } from "react";
import { reportIncident } from "../../services/incidentService";
import { useDispatch } from "react-redux";
import { addIncident } from "../../redux/slices/incidentsSlice";

const IncidentReporting = () => {
  const dispatch = useDispatch();
  const [incidentData, setIncidentData] = useState({
    title: "",
    description: "",
    location: "",
    severity: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIncidentData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newIncident = await reportIncident(incidentData);
      dispatch(addIncident(newIncident));
      alert("Incident reported successfully!");
    } catch (error) {
      console.error("Error reporting incident", error);
    }
  };

  return (
    <div className="incident-reporting">
      <h2>Report an Incident</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={incidentData.title}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          value={incidentData.description}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="location"
          placeholder="Location"
          value={incidentData.location}
          onChange={handleChange}
        />
        <select
          name="severity"
          value={incidentData.severity}
          onChange={handleChange}
        >
          <option value="">Select Severity</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
        <button type="submit">Report Incident</button>
      </form>
    </div>
  );
};

export default IncidentReporting;
